import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import ProfessionalSituation from "../components/ProfessionalSituation";

const ProfessionalSituationPage = () => {
  return (
    <>

      {/* MasterLayout */}

        {/* Breadcrumb */}
        <Breadcrumb title="Professional Situation" />

        <ProfessionalSituation />


    </>
  );
};

export default ProfessionalSituationPage; 